import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["kindMessage", "size", "icon"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useKind } from './helper';
import { SIZES, KINDS } from '../helper';

const resolveMarginLeft = size => {
  const margin = {
    lg: "calc(var(--size-spacing-01) * -1)",
    md: "0",
    sm: "0"
  };
  return margin[size] ? margin[size] : margin.lg;
};

const resolveMarginRight = size => {
  const margin = {
    lg: "var(--size-spacing-04)",
    md: "var(--size-spacing-04)",
    sm: "var(--size-spacing-02)"
  };
  return margin[size] ? margin[size] : margin.lg;
};

const Root = styled.div.withConfig({
  displayName: "MessageIcon__Root",
  componentId: "sc-1mxc0jw-0"
})(["display:inline-flex;margin-left:", ";margin-right:", ";"], _ref => {
  let {
    size
  } = _ref;
  return resolveMarginLeft(size);
}, _ref2 => {
  let {
    size
  } = _ref2;
  return resolveMarginRight(size);
});
const MessageIcon = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
    kindMessage,
    size,
    icon
  } = _ref3,
      rest = _objectWithoutPropertiesLoose(_ref3, _excluded);

  const {
    Icon
  } = useKind(kindMessage);
  return Icon && /*#__PURE__*/React.createElement(Root, _extends({
    ref: ref,
    size: size
  }, rest), icon ? icon : /*#__PURE__*/React.createElement(Icon, {
    size: "md"
  }));
});
MessageIcon.display = 'MessageIcon';
MessageIcon.Style = Root;
MessageIcon.defaultProps = {
  size: SIZES.LG,
  kindMessage: KINDS.DEFAULT
};
process.env.NODE_ENV !== "production" ? MessageIcon.propTypes = {
  /**
   * Sets custom icon.
   */
  icon: PropTypes.element,

  /**
   * @ignore
   * Set internally by Toast or Snackbar Component
   */
  size: PropTypes.oneOf([SIZES.SM, SIZES.MD, SIZES.LG]),

  /**
   *  @ignore
   * Sets button kind for styling. Used internally by Toast and Snackbar
   * @type {'default' | 'primary' | 'success' | 'danger' | 'warning' | 'help'}
   */
  kindMessage: PropTypes.oneOf([KINDS.DEFAULT, KINDS.PRIMARY, KINDS.SUCCESS, KINDS.DANGER, KINDS.WARNING, KINDS.HELP])
} : void 0;
export default MessageIcon;